/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Audit_DescInputs */

const en_fw_audit_desc = /** @type {(inputs: Fw_Audit_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every evidence run, override, phase approval and status change of a workspace, last 90 days. Useful for a client handover or an EU AI Act record.`)
};

const id_fw_audit_desc = /** @type {(inputs: Fw_Audit_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua proses bukti, override, persetujuan fase, dan perubahan status sebuah workspace, 90 hari terakhir. Berguna untuk serah terima ke klien atau catatan EU AI Act.`)
};

/**
* | output |
* | --- |
* | "Every evidence run, override, phase approval and status change of a workspace, last 90 days. Useful for a client handover or an EU AI Act record." |
*
* @param {Fw_Audit_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_audit_desc = /** @type {((inputs?: Fw_Audit_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Audit_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_audit_desc(inputs)
	return en_fw_audit_desc(inputs)
});